export default function AdditionalInfo({ balance = 0, shortfall = 0, onViewReturns }) {
  return (
    <div style={{
      display: "flex",
      flexDirection: "column",
      gap: "10px",
      alignItems: "stretch",
      flexShrink: 0,
      width: "202px",
      alignSelf: "center",
      marginRight: "40px",
      marginTop: "-20px",
    }}>
      <div
        style={{
          minWidth: "200px",
          borderRadius: "20px",
          padding: "24px",
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          gap: "8px",
          background: "rgba(230, 253, 231, 0.8)",
          boxSizing: "border-box",
        }}
      >
        <div style={{ fontSize: "14px", fontWeight: 400, color: "#000000", lineHeight: "20px" }}>
          Balance
        </div>
        <div style={{ fontSize: "24px", fontWeight: 600, color: "#000000", lineHeight: "32px" }}>
          ${balance}
        </div>
      </div>

      <div
        style={{
          minWidth: "200px",
          borderRadius: "20px",
          padding: "24px",
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          gap: "8px",
          background: "rgba(255, 159, 163, 0.9)",
          boxSizing: "border-box",
        }}
      >
        <div style={{ fontSize: "14px", fontWeight: 400, color: "#000000", lineHeight: "20px" }}>
          Expected Shortfall
        </div>
        <div style={{ fontSize: "24px", fontWeight: 600, color: "#000000", lineHeight: "32px" }}>
          {shortfall}
        </div>
      </div>

      <button
        onClick={onViewReturns}
        style={{
          minWidth: "200px",
          width: "100%",
          flexShrink: 0,
          height: "48px",
          border: "1px solid #5da1ff",
          background: "transparent",
          color: "#5da1ff",
          borderRadius: "20px",
          padding: "8px 24px",
          fontSize: "12px",
          fontWeight: 510,
          cursor: "pointer",
          whiteSpace: "nowrap",
          boxSizing: "border-box",
          textAlign: "center",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        View Granular Stock Returns
      </button>
    </div>
  );
}
